import { PurchaseOrderActions } from "@finway-group/shared/lib/models/purchaseOrder/purchaseOrderStatusAction.enum"
import { Table, TablePaginationConfig } from "antd"
import { SorterResult } from "antd/lib/table/interface"
import React from "react"
import { useTranslation } from "react-i18next"
import { EmptyTableData } from "~Components/emptyTableData"
import { RoutePathEnum } from "~Shared/router/RoutePath.enum"
import { GenerateProcurementColumns } from "../columns/ProcurementColumns"
import { usePurchaseOrdersTable } from "../hooks/usePurchaseOrdersTable.hook"
import { usePurchaseOrderTransition } from "../hooks/usePurchaseOrderTransition.hook"
import { ProcurementTableColumn, PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { mapProcurementToTable } from "../types/utils/helper.util"

interface ProcurementTabProps {
    procurementData: Array<PurchaseOrder>
    pagination: Partial<TablePaginationConfig>

    setCurrentPage: (page: number) => void
    setPageSize: (size: number) => void
    setSorting: (sorting: { field?: string; order?: SorterResult<ProcurementTableColumn>["order"] }) => void
    isTableEmpty: boolean
    isNoSearchDataFound: boolean
}
export const ProcurementTab = ({ procurementData, pagination, setCurrentPage, setPageSize, setSorting, isTableEmpty, isNoSearchDataFound }: ProcurementTabProps) => {
    const { t } = useTranslation()
    const { transitionPO } = usePurchaseOrderTransition()

    const { tableProps } = usePurchaseOrdersTable<ProcurementTableColumn>({
        data: procurementData.map(mapProcurementToTable),
        generateColumns: GenerateProcurementColumns,
        basePath: RoutePathEnum.PURCHASE_ORDER_DETAILS_PAGE,
        // Enable pagination
        enablePagination: true,
        totalItems: pagination.total ?? 0,
        // Pass custom handlers if needed
        columnFunctions: {
            updateRecord: (record) => transitionPO(record._id, { action: PurchaseOrderActions.SUBMIT_FOR_FULFILLMENT }),
            deleteRecord: () => {},
            getRecord: () => {},
            t,
        },

        currentPage: pagination.current ?? 1,
        pageSize: pagination.pageSize ?? 10,
        setCurrentPage,
        setPageSize,
        setSorting,
    })

    if (isTableEmpty || isNoSearchDataFound) {
        return <EmptyTableData isSearchOrFilterActive={isNoSearchDataFound} title={t("info:empty_state.procurement.title")} message={t("info:empty_state.procurement.message")} />
    }

    return (
        <div className="flex flex-col gap-16 overflow-y-auto">
            <Table {...tableProps} />
        </div>
    )
}
